import api from '../../services/api';

export const get_accounts_profile = (params) => api.get('/accounts/profile/', { params });
export const post_accounts_admin_qr_bulk_generate = (data) => api.post('/accounts/admin/qr/bulk-generate/', data);
export const post_accounts_profile_generate_qr = (data) => api.post('/accounts/profile/generate-qr/', data);
export const get_page_qr_choices = () => api.get('/accounts/admin/qr/page-choices/');
export const post_generate_page_qr = (data) => api.post('/accounts/admin/qr/generate-page/', data);
export const post_generate_custom_qr = (data) => api.post('/accounts/admin/qr/generate-custom/', data);
export const get_generated_qr_list = (params) => api.get('/accounts/admin/qr/list/', { params });
export const delete_generated_qr = (id) => api.delete(`/accounts/admin/qr/${id}/delete/`);

// ─── Member ID Card assignment ───
export const get_qr_members = (params) => api.get('/accounts/admin/qr/members/', { params });
export const post_assign_qr = (data) => api.post('/accounts/admin/qr/assign/', data);
export const post_unassign_qr = (data) => api.post('/accounts/admin/qr/unassign/', data);
export const patch_member_designation = (id, data) => api.patch(`/accounts/admin/qr/members/${id}/designation/`, data);
